.layout {
  flex: 1;
  display: grid;
  grid-template-columns: minmax(0, 5fr) minmax(0, 6fr);
  min-block-size: 100dvh;
}

.brandPanel {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: var(--space-8);
  padding: var(--space-10);
  background: var(--nile-900);
  color: #e3ece9;
  overflow: hidden;
}

/* Original motif: river contour lines over a deep teal field (pure CSS, no imagery). */
.brandPanel::before {
  content: '';
  position: absolute;
  inset: 0;
  background:
    repeating-radial-gradient(
      circle at 110% 120%,
      transparent 0 22px,
      rgb(221 181 109 / 0.09) 22px 23px
    ),
    linear-gradient(160deg, var(--nile-800) 0%, var(--nile-950) 100%);
  pointer-events: none;
}

.brandPanel > * {
  position: relative;
}

.brandMark {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  font-size: var(--text-xl);
  font-weight: var(--weight-bold);
}

.brandHeadline {
  max-inline-size: 26rem;
  font-size: var(--text-2xl);
  font-weight: var(--weight-semibold);
  line-height: 1.35;
  color: #ffffff;
}

.points {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  margin: 0;
  padding: 0;
  list-style: none;
}

.points li {
  display: flex;
  gap: var(--space-3);
  align-items: flex-start;
  color: #c9dad6;
}

.points svg {
  flex: none;
  margin-block-start: 0.2em;
  color: var(--sand-300);
}

.formPanel {
  display: flex;
  flex-direction: column;
  padding: var(--space-6) var(--gutter);
  background: var(--color-bg);
}

.formTop {
  display: flex;
  justify-content: flex-end;
}

.formWrap {
  flex: 1;
  display: grid;
  place-items: center;
  padding-block: var(--space-8);
}

.form {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
  inline-size: min(26rem, 100%);
}

.formHeader {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

.formTitle {
  font-size: var(--text-2xl);
}

.formSubtitle {
  color: var(--color-text-muted);
}

.switch {
  color: var(--color-text-muted);
  font-size: var(--text-sm);
}

.submit {
  inline-size: 100%;
}

@media (max-width: 56rem) {
  .layout {
    grid-template-columns: 1fr;
    grid-template-rows: auto 1fr;
  }

  .brandPanel {
    padding: var(--space-5) var(--gutter);
    gap: var(--space-3);
  }

  .brandHeadline {
    font-size: var(--text-lg);
  }

  .points {
    display: none;
  }

  .formWrap {
    place-items: start center;
    padding-block: var(--space-4);
  }
}
